import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class ManualPricingCheckbox {
  public id: string = null;
  public value: boolean = true;
  public locked: boolean = false;
}

export class ManualPricingFixingTabModel {
  public id: string = null;
  public title: string = null;
  public code: string = null;
  public codeTooltip: string = null;
  public time: string = null;
  public date: string = null;
  public rateData: Array<ManualPricingRateModel> = new Array<ManualPricingRateModel>();
  public checkboxFixing: ManualPricingCheckbox = new ManualPricingCheckbox();
  public fixingTimestamp: number;
  public warning: string = null;
  public nothingToPrice: boolean = false;
}

export class ManualPricingRateModel {
  public id: string = null;
  public fixingCode = null;
  public checkbox: ManualPricingCheckbox = new ManualPricingCheckbox();
  public instrument: string = null;
  public base: string = null;
  public nonBase: string = null;
  public bid: CubiqTS.BigNumber = null;
  public mid: string = "";
  public offer: CubiqTS.BigNumber = null;
  public precision: number;
  public midPrecision: number;
  public disabled: boolean = false;
  public first: boolean = false;
  public last: boolean = false;

  /** Used for Fat finger checks */
  public ccyPair: CubiqTS.CurrencyPairImpl = null;
  public originalMidRate: CubiqTS.BigNumber = null;
  public allowTolerance: boolean = false;
  public toleranceError: string = null;

  constructor(id: string) {
    this.id = id;
  }

  public get faded(): boolean {
    return this.disabled || !this.checkbox.value;
  }

  public validBidOffer(): boolean {
    if (this.offer == null || this.bid == null) return false;

    return this.offer instanceof CubiqTS.BigNumber && this.bid instanceof CubiqTS.BigNumber;
  }
}
